import {
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { PopoverController } from "ionic-angular";
import SelectOption from "../multi-select-dropdown/selection-option";

@Component({
  selector: "multi-select-input",
  templateUrl: "multi-select-input.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectInputComponent),
      multi: true,
    },
  ],
})
export class MultiSelectInputComponent implements ControlValueAccessor {
  @ViewChild("itemContainer") itemContainer: ElementRef;
  @HostBinding("attr.id")
  externalId = "";
  selectedOptionsDisplay: string = "";
  private _options: SelectOption[] = [];
  private _selected: string[] = [];
  private _ID = "";
  private _placeholder: string = "Default Placeholder";

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private popover: PopoverController) {}

  selectOption(ev) {
    if (!this.options || this.options.length === 0) {
      this.options = [
        {
          checked: false,
          name: "A",
          value: "A",
        },
      ];
    }
    const searchable = false;
    const searchPlaceholder = "";
    const emptyMessage = "";
    const containerWidth = this.itemContainer.nativeElement.offsetWidth;
    const isLongOptionName = true;
    //let options = this.disciplineOption.map(a => ({ ...a }));
    const popover = this.popover.create(
      "CareTeamsSelectPage",
      {
        options: this.options,
        searchable,
        searchPlaceholder,
        emptyMessage,
        isMultiSelect: true,
        containerWidth: containerWidth,
        isLongOptionName,
        isAutoWidth: true,
      },
      { cssClass: "multiple-select-custom-popover" }
    );
    popover.onDidDismiss((data) => {
      if (data && data.options) {
        this.selected = data.options
          .filter((x: SelectOption) => {
            return x.checked;
          })
          .map((x: SelectOption) => {
            return x.value;
          });

        // this.disciplineOption = data.options;
        // this.setDiscipline();
        // this.search();
      }
    });
    // popover.present({ ev });
    popover.present({ ev });
  }

  // region Getters and Setters
  get options(): SelectOption[] {
    return this._options;
  }

  @Input()
  set options(value: SelectOption[]) {
    this._options = value;
  }

  get selected(): string[] {
    return this._selected;
  }

  set selected(value: string[]) {
    this._selected = value;
    this.selectedOptionsDisplay = this.selected.join(", ");
    this.onChange(value);
    this.onTouched();
  }

  @Input()
  set id(value: string) {
    this._ID = value;
    this.externalId = null;
  }

  get id() {
    return this._ID;
  }

  get placeholder(): string {
    return this._placeholder;
  }

  @Input()
  set placeholder(value: string) {
    this._placeholder = value;
  }

  // endregion

  // region Implementation for ControlValueAccessor
  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.selected = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // endregion
}



// WEBPACK FOOTER //
// ./src/components/common/multi-select-input/multi-select-input.ts